import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  prefix: "tw-",
})

/**
 * A helper function to process class names.
 * @param inputs - The class names to process.
 * @returns The processed class names.
 */
export function classnames(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export const cn = classnames
